<template>
  <div class="plant">
    <transition :name="transitionName">
      <router-view class="Router"></router-view>
    </transition>
    <img class="plant-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
export default {
  name: 'Plant',
  data () {
    return {
      transitionName: 'slide-fade'
    }
  }
}
</script>

<style scoped>
  @import "Plant.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/plant/Plant.vue